import { ATEK_ORG_ID } from '@/features/users/utils/constants';

export function getQmsOrganisationId(sessionOrganisation?: string | null): string {
  const organisation = sessionOrganisation?.trim();
  return organisation || ATEK_ORG_ID;
}
